export default "__VITE_ASSET__8b6a0eb4__"